import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=78838f17&scoped=true"
import script from "./FormPreview.vue?vue&type=script&lang=js"
export * from "./FormPreview.vue?vue&type=script&lang=js"
import style0 from "./FormPreview.vue?vue&type=style&index=0&id=78838f17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78838f17",
  null
  
)

export default component.exports